import React, {Component} from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import { getRandomColor } from '../../common/colorUtils';

const DEFAULT_COLOR = '#34A4EB';
class SimpleLineChart extends React.Component {
    renderLines() {
        const {
            dataValueName = 'value',
            lineType = 'linear',
            lineColor = '#34A4EB',
        } = this.props;

        return <Line name='Antal' type={lineType} dataKey={dataValueName} stroke={lineColor} activeDot={{r: 8}} dot={this.getDot(lineColor)}/>;
    }

    renderMultipleLines() {
        const {
            lineType = 'linear',
            lineKeys,
        } = this.props;

        return Object.keys(lineKeys).map(key => {
           return <Line key={key} name={lineKeys[key]} type={lineType} stroke={this.getColor(key)} dataKey={key} activeDot={{r: 8}} dot={this.getDot(this.getColor(key))}/>
        });
    }

    getColor(context = null) {
        let color = this.props.lineColor || DEFAULT_COLOR;
        if(!context) {
            return color;
        }

        if(!this.colors) {
            this.colors = {[context]: DEFAULT_COLOR}
        }
        else if(!this.colors[context]) {
            this.colors[context] = getRandomColor();
        }

        return this.colors[context];
    }

    getDot(lineColor) {
        let {
            dot = true,
            data,
        } = this.props;

        if(data.length < 2) {
            dot = {r: 8, fill: lineColor};
        }

        return dot;
    }

    formatXAxisLabels(data){
        // replace dates DD-MM-YYYY with DD/MM for daily stats
        let dataFormatted = [];
        data.forEach(dataItem => {

            let keyChunks = dataItem.key.split('-');
            var copy = Object.assign({}, dataItem);
            if (keyChunks.length > 1) {
                // remove leading zero's
                copy.key = (+keyChunks[0]) + '/' + (+keyChunks[1]);
            }
            dataFormatted.push(copy);
        });
        return dataFormatted;
    }

    render () {
        let {
            data,
            width = 600,
            height = 400,
            dataKeyName = "key",
            lineKeys,
        } = this.props;

        const dataFormatted = this.formatXAxisLabels(data);

        return (
            <LineChart width={width} height={height} data={dataFormatted}
                       margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey={dataKeyName}/>
                <YAxis/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Tooltip/>
                <Legend />
                {lineKeys ? this.renderMultipleLines() : this.renderLines()}
            </LineChart>
        );
    }
}

export default SimpleLineChart;


// WEBPACK FOOTER //
// ./web/src/components/charts/SimpleLineChart.jsx